(function () {
  'use strict';

  angular
      .module('tfc.retailer.AggregationDetail')
      .directive('tfcAggregationDetail', tfcAggregationDetail)
      .controller('tfcAggregationDetailCtrl', tfcAggregationDetailCtrl);

  function tfcAggregationDetail(){
    return {
      restrict: 'E',
      controller:'tfcAggregationDetailCtrl as vm',
      templateUrl : 'Util/AggregationDetail/AggregationDetail.tmpl.html',
      bindToController: true,
      scope : {
        aggregationDetail:"="
      }
    }
  }

  function tfcAggregationDetailCtrl(Auth) {
    var vm = this;
    vm.isAggregationDetailVisible = Auth.can('viewAggregationLog');
  }

})();